import { gql } from '@apollo/client'
import { SHARED_FACILITY_DATA } from './facilitiesFragments'

export const getAllFacilities = gql`
  ${SHARED_FACILITY_DATA}
  query AllFacilities {
    featuredFacilities: allFacilities(
      orderBy: FACILITIES_NAME_ASC
      condition: { facilitiesFeatured: true }
    ) {
      totalCount
      nodes {
        ...SharedFacilityData
      }
    }
    allFacilities(orderBy: FACILITIES_NAME_ASC) {
      totalCount
      nodes {
        ...SharedFacilityData
      }
    }
  }
`

export const getFeaturedFacilities = gql`
  ${SHARED_FACILITY_DATA}
  query featuredFacilitiesOnly {
    featuredFacilities(condition: { facilitiesFeatured: true }) {
      totalCount
      nodes {
        ...SharedFacilityData
      }
    }
  }
`

export const getFacilityById = gql`
  ${SHARED_FACILITY_DATA}
  query FacilityById($facilitiesId: UUID) {
    allFacilities(condition: { facilitiesId: $facilitiesId }) {
      totalCount
      nodes {
        ...SharedFacilityData
      }
    }
  }
`
